module.exports = __webpack_public_path__ + "static/img/menu.d6e12a74.png";